import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICompany } from "src/models/Stores/Company.models";

interface CompanyState {
  companies: ICompany[];
  companyToEdit: ICompany | null;
}

const initialState: CompanyState = {
  companies: [],
  companyToEdit: null,
};

const companySlice = createSlice({
  name: "Company",
  initialState,
  reducers: {
    setCompanyList: (state, action: PayloadAction<ICompany[]>) => {
      state.companies = action.payload;
    },
    concatListCompany: (
      state: CompanyState,
      action: PayloadAction<ICompany[]>
    ) => {
      state.companies = [...state.companies.concat(action.payload)];
    },
    setCompanyToEdit: (state, action: PayloadAction<ICompany | null>) => {
      state.companyToEdit = action.payload;
    },
    addCompany: (state, action: PayloadAction<ICompany>) => {
      state.companies.push(action.payload);
    },
    updateCompany: (state, action: PayloadAction<ICompany>) => {
      let itemIndex = state.companies.findIndex(
        item => item.companyId === action.payload.companyId
      );
      if (itemIndex !== -1) state.companies[itemIndex] = action.payload;
    },
    deleteCompany: (state, action: PayloadAction<string>) => {
      const newArray = state.companies.filter(
        item => item.companyId !== action.payload
      );
      state.companies = newArray;
    },
  },
});

export const {
  setCompanyList,
  concatListCompany,
  setCompanyToEdit,
  addCompany,
  updateCompany,
  deleteCompany,
} = companySlice.actions;

export default companySlice.reducer;
